export default __webpack_public_path__ + "static/media/handshake.44bab6d4.webp";